import { render } from "./BrushWithColor.vue?vue&type=template&id=71e70206"
import script from "./BrushWithColor.vue?vue&type=script&lang=js"
export * from "./BrushWithColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__